if (!customElements.get('park-chapter-nav')) {
  customElements.define('park-chapter-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.nav = this.querySelector('nav');
      if (!this.nav) return;
      this.links = [...this.nav.querySelectorAll('a[href^="#"]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width:760px)');
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => this.update()); };
      this.nav.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        const top = scrollY + target.getBoundingClientRect().top - this.offset();
        window.scrollTo({ top, behavior: this.motion.matches ? 'instant' : 'smooth' });
        history.replaceState(null, '', link.hash);
      }, options);
      ['scroll', 'resize', 'pageshow'].forEach(type => window.addEventListener(type, this.schedule, { ...options, passive: true }));
      this.motion.addEventListener('change', this.schedule, options);
      this.mobile.addEventListener('change', this.schedule, options);
      document.addEventListener('shopify:section:load', this.schedule, options);
      this.schedule();
    }
    offset() { return (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height')) || 0) + (this.dataset.sticky === 'true' ? this.nav.getBoundingClientRect().height : 0) + 16; }
    update() {
      this.frame = 0;
      if (!this.isConnected) return;
      const offset = this.offset();
      let current;
      this.links.forEach(link => { const target = document.getElementById(link.hash.slice(1)); if (target && target.getBoundingClientRect().top <= offset + 5) current = link; });
      this.links.forEach(link => {
        const active = link.hasAttribute('aria-current');
        if (link !== current) { link.removeAttribute('aria-current'); return; }
        link.setAttribute('aria-current', 'location');
        if (!active && this.mobile.matches) this.nav.scrollTo({ left: Math.max(0, link.offsetLeft - this.nav.offsetLeft - (this.nav.clientWidth - link.offsetWidth) / 2), behavior: this.motion.matches ? 'instant' : 'smooth' });
      });
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; cancelAnimationFrame(this.frame); this.frame = 0; }
  });
}
